<template>
  <div>
    <!-- 只显示为关联的班组 -->
    <el-form :model="searchForm" ref="searchFormRef" label-suffix=':' label-width="80px" v-show="searchShowFlag">
      <el-row :gutter="24">
        <el-col span="6">
          <el-form-item label="班组名称" prop="checkPass">
            <el-input
              clearable
              v-model="searchForm.name"
              placeholder="班组名称"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col span="6">
          <el-form-item label="服务类型" prop="checkPass">
            <el-select v-model="searchForm.moduleType" placeholder="服务类型" style="width:100%">
              <el-option
                v-for="item in moduleTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col span="18">
          <div style="float:right">
            <el-button icon="el-icon-search" type="primary" @click="search" size="small">
              搜索
            </el-button>
            <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      ref="crud"
      @selection-change="selectionChange"
      @on-load="onLoad"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
    >
      <template slot="choice" slot-scope="scope">
        <el-radio v-model="radio" :label="scope.row.id"> {{ ' ' }}</el-radio>
      </template>
      <!-- <template slot="menuRight">
        <el-tooltip class="item" effect="dark" content="搜索" placement="top-start">
          <el-button size="small" icon="el-icon-search" circle @click="openSearchBox"></el-button>
        </el-tooltip>
      </template> -->
    </avue-crud>
    <div class="btnArea" style="text-align:right;">
      <el-button size="small" type="primary" icon="el-icon-circle-plus-outline" @click="submitData"
        >提交</el-button
      >
      <el-button
        size="small"
        icon="el-icon-circle-close"
        style="margin-right:24px"
        @click="cancelOperate"
        >取消</el-button
      >
    </div>
  </div>
</template>

<script>
import { getAddRelationDevice, settingRelationDevice } from '@/api/crmedical/device/deviceRelation';
import {
  groupPage,
  relationGroup,
  lookStandardGroup,
  modulesSetting,
} from '@/api/crmedical/comprehensiveInspect/index.js';
import { fastLerp } from 'zrender/lib/tool/color';
export default {
  props: ['row'],
  data() {
    return {
      searchShowFlag: true,
      relateAllGroupForm: {},
      moduleTypeList: [],
      data: [],
      searchForm: {
        moduleType: '',
        name: '',
      },
      radio: '',
      option: {
        height: 'auto',
        calcHeight: 300,
        menu: false,
        tip: false,
        border: true,
        index: true,
        selection: false,
        searchShowBtn:false,
     
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        columnBtn: false,
        column: [
          {
            label: '选择',
            prop: 'choice',
            slot: true,
            align: 'center',
          },
          {
            label: '班组名称',
            prop: 'name',
          },
          // {
          //   label: '服务类型',
          //   prop: 'moduleType',
          //   dataType: 'string',
          //   props: {
          //     label: 'dictValue',
          //     value: 'dictKey',
          //   },
          //   dicUrl: '/api/v4ward/ordersetting/setting/modules/'+this.row.projectId,
          // },
          {
            label: '责任人',
            prop: 'principalNames',
          },

          {
            label: '班组成员',
            prop: 'crewNames',
          },
        ],
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
    };
  },
  created() {
    this.getRelativeGrop();
    this.relateAllGroupForm = Object.assign({}, this.searchForm);
    this.initData();
  },
  mounted() {
    // this.option.height = 600;
  },
  methods: {
    cancelOperate() {
      this.$emit('close');
    },
    getRelativeGrop() {
      lookStandardGroup({
        standardId: this.row.id,
        projectId: this.row.projectId,
        status: this.row.status,
      }).then(({ data }) => {
        this.radio = data[0].id;
        console.log('已选择的班组', this.radio);
      });
    },
    submitData() {
      console.log(this.radio);
      this.relateChoiceGroup();
    },
    openSearchBox() {
      this.searchShowFlag = !this.searchShowFlag;
      if (this.searchShowFlag) {
        this.option.height = 200;
      } else {
        this.option.height = 400;
      }
      this.$refs.crud.getTableHeight();
    },

    searchClear() {
      this.searchForm.name = '';
      this.searchForm.moduleType = '';
    },
    relateChoiceGroup() {
      if (this.radio) {
        relationGroup({
          groupIds: this.radio,
          standardId: this.row.id,
          projectId: this.row.projectId,
        }).then(() => {
          this.$message.success('关联成功');
          this.$emit('submitGroup');
        });
      } else {
        this.$message({
          showClose: true,
          message: '没有勾选任何班组',
          type: 'warning',
        });
        return;
      }
    },
    relateAllGroup() {
      if (this.page.total > 0) {
        relationGroup(
          Object.assign(
            {},
            {
              standardId: this.row.id,
              projectId: this.row.projectId,
            },
            this.relateAllGroupForm
          )
        ).then(() => {
          this.$message.success('关联成功');
          this.onLoad();
        });
      } else {
        this.$message({
          showClose: true,
          message: '没有可关联的设备',
          type: 'warning',
        });
        return;
      }
    },
    selectionChange(val) {
      console.log(val);
      let Ids = [];
      val.forEach((element) => {
        Ids.push(element.id);
      });
      this.groupIds = Ids.join(',');
    },
    search() {
      this.page.currentPage = 1;
      this.relateAllGroupForm = Object.assign({}, this.searchForm);
      this.onLoad();
    },

    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      this.relateAllGroupForm = Object.assign({}, this.searchForm);
      groupPage(
        Object.assign(
          {},
          {
            current: this.page.currentPage,
            size: this.page.pageSize,
            standardId: this.row.id,
            projectId: this.row.projectId,
          },
          this.searchForm
        )
      ).then(({ data }) => {
        this.data = data;

        this.loading = false;
      });
    },
    initData() {
      modulesSetting(this.row.projectId).then((res) => {
        this.moduleTypeList = res.data;
      });
    },
    getObjectTypeName(dictKey) {
      let ObjectTypeName;
      this.objectType.forEach((element) => {
        if (element.dictKey == dictKey) {
          ObjectTypeName = element.dictValue;
        }
      });
      return ObjectTypeName;
    },
  },
};
</script>

<style scoped>
::v-deep .avue-crud .el-form-item {
  display: block;
}
/* ::v-deep .el-table--small {
  height: 330px!important;
} */
</style>
